<template>
  <div class="traincheck">
    <div class="content" v-if="isShowList">
      <h3>{{ description }}</h3>
      <p>下面是本次培训的安排：</p>
      <div class="list-box">
        <template v-for="(item, key) in list">
          <div :class="{'list': true, 'first': item.isExpireFirst && item.isExpireFirst == 'Yes'}">
            <div class="top">
              <div class="xuhao"><span>{{ key+1 }}</span></div>
              <div class="text">
                <p class="name">【培训讲师】：{{ item.teacherName }}</p>
                <p class="gary" :title="item.content">【培训内容】：{{ item.content }}</p>
                <p class="gary">【培训日期】：{{ item.startTime.substring(0, 10) }}（{{ item.startTime.substring(11, 16) }}-{{ item.endTime.substring(11, 16) }}）</p>
              </div>
              <div class="button">
                <a class="pjia" @click="showPjia(item.courseId)">匿名评价</a>
              </div>
            </div>
            <div class="bottom">
              <div class="c-list">
                <template v-if="item.signTimes != null">
                  <span v-for="(c, index) in item.signTimes">{{ c.substring(11, 19) }}（已签到）</span>
                </template>
                <template v-else>
                  <p>您还没有签到</p>
                </template>
              </div>
              <!--<el-tooltip v-if="item.isExpire == 'No'" class="item" effect="dark" content="*请在讲师要求进行签到时才操作，请勿提前签到" placement="top-end">
                <a class="btn" @click="checkIn(item.courseId)">点击签到</a>
              </el-tooltip>-->
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="pjia-box" v-if="isShowPjia">
      <h3>参与评价</h3>
      <p>感谢您的评价，以帮助我们改进培训质量，请放心参与评价，我们将不会记录任何您的个人信息</p>
      <div class="box">
        <div class="rate-box-first">
          <span class="first">课程评价</span>
          <el-rate v-model="courseScore" :allow-half="true"></el-rate>
          <span class="close" v-if="!isShowMore" @click="showMore">点击展开</span>
          <span class="close" v-else @click="closeMore">点击收起</span>
        </div>
        <div class="rate-box" v-show="isShowMore">
          <span class="first">实用性</span>
          <el-rate v-model="utility" :allow-half="true"></el-rate>
          <span class="close"></span>
        </div>
        <div class="rate-box" v-show="isShowMore">
          <span class="first">条理性</span>
          <el-rate v-model="reasonability" :allow-half="true"></el-rate>
          <span class="close"></span>
        </div>
        <div class="rate-box" v-show="isShowMore">
          <span class="first">通用性</span>
          <el-rate v-model="popularity" :allow-half="true"></el-rate>
          <span class="close"></span>
        </div>
        <div class="rate-box-first">
          <span class="first">讲师评价</span>
          <el-rate v-model="teacherScore" :allow-half="true"></el-rate>
          <span class="close" v-if="!isShowMoreTwo" @click="showMoreTwo">点击展开</span>
          <span class="close" v-else @click="closeMoreTwo">点击收起</span>
        </div>
        <div class="rate-box" v-show="isShowMoreTwo">
          <span class="first">互动性</span>
          <el-rate v-model="interaction" :allow-half="true"></el-rate>
          <span class="close"></span>
        </div>
        <div class="rate-box" v-show="isShowMoreTwo">
          <span class="first">纪律性</span>
          <el-rate v-model="discipline" :allow-half="true"></el-rate>
          <span class="close"></span>
        </div>
        <div class="rate-box" v-show="isShowMoreTwo">
          <span class="first">亲和力</span>
          <el-rate v-model="affinity" :allow-half="true"></el-rate>
          <span class="close"></span>
        </div>
        <div class="rate-box-first">
          <span class="first">其他建议</span>
          <el-input type="textarea" v-model="advice" autosize></el-input>
        </div>
        <div class="btn-box">
          <p>
            <el-button plain class="margin-r" @click="gotoList">返回</el-button>
            <a class="btn" @click="submitPjia">匿名评价</a>
          </p>
          <p>请放心评价，我们将不会记录您的个人信息。</p>
        </div>
      </div>
    </div>
    <div class="succ-box" v-if="isShowPjiaSucc">
      <p><span class="el-icon-success"></span></p>
      <p><b>提交成功！感谢您的评价！</b></p>
      <p><a class="btn" @click="closePjiaSucc">返回</a></p>
    </div>
    <!--立即签到弹框-->
    <div class="check-box-bg" v-if="isShowCheck"></div>
    <div class="check-box" v-if="isShowCheck" @click="checkIn()">
      <p>立即签到</p>
      <p><span v-html="djs"></span></p>
    </div>
    <div class="check-succ-box-bg" v-if="isShowCheckSucc" @click="isShowCheckSucc = false"></div>
    <div class="check-succ-box" v-if="isShowCheckSucc">
      <p><img src="../../../static/icon_qiandao.png" /></p>
      <p><b>签到成功！</b></p>
      <p><a class="btn" @click="isShowCheckSucc = false">确定</a></p>
    </div>
    <div class="login-box" v-if="isShowLogin">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="账号" prop="loginName">
          <el-input type="text" v-model="form.loginName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="loginPwd">
          <el-input type="password" v-model="form.loginPwd" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item>
          <a class="btn" @click="login">登录</a>
        </el-form-item>
      </el-form>
    </div>
    <div class="template-box" v-if="isShowTemplate">
      <h3>填写问卷</h3>
      <p>本人郑重承诺以下填写的信息属实，如因信息不属实产生的后果由自己承担。每个问题都需要填写！</p>
      <el-form ref="wjform" :model="wjform" class="intent-content">
        <template v-for="(item, key) in questionList">
          <el-form-item :label="key+1+'、'+item.paramName" v-if="questionList.length>0" class="is-required">
            <template v-if="item.paramType == 'TEXT'">
              <el-input v-model="wjform.answerList[item.paramId]"></el-input>
            </template>
            <template v-if="item.paramType == 'RADIO'">
              <el-radio-group v-model="wjform.answerList[item.paramId]">
                <template v-for="s in item.optionList" >
                  <el-radio :label="s"></el-radio>
                </template>
              </el-radio-group>
            </template>
          </el-form-item>
        </template>
        <p><a class="btn" @click="submitInfo">提交</a></p>
      </el-form>
    </div>
    <div class="recruit-box" v-if="isShowRecruit">
      <p><img src="../../../static/icon_baoming.png" /></p>
      <p class="text">{{ description }}</p>
      <p><a class="btn" @click="recruitFun">我要报名</a></p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      scheduleId: '',
      disabled: false,
      isShowMore: true,
      isShowMoreTwo: true,
      isShowList: false, //默认显示列表
      isShowPjia: false, //显示评价
      isShowPjiaSucc: false, //显示评价成功提示
      isShowCheckSucc: false, //签到成功提示
      isShowLogin: false, //显示登录
      isShowRecruit: false, //显示报名
      isShowTemplate: false, //显示问卷调查
      isShowCheck: false, //显示立即签到弹框
      interval: null, //轮询状态
      time: 0, //签到剩余时间
      djs: '', //倒计时
      checkCourseId: '', //当前签到课程id
      description: '', //课程说明
      list: [],
      courseId: '', //评价时课程id
      advice: '', //建议
      courseScore: 0, //课程评分
      utility: 0, //实用性
      popularity: 0, //通俗性
      reasonability: 0, //合理性
      teacherScore: 0, //老师评分
      interaction: 0, //互动性
      discipline: 0, //纪律性
      affinity: 0, //亲和力
      form: {
        loginName: '',
        loginPwd: '',
        deviceType: 'PC'
      },
      questionList: [], //问卷调查题目
      wjform: {
        answerList: []
      },
      rules: {
        loginName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        loginPwd: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    let idarry = this.$route.query.schedule.split('y')
    this.scheduleId = idarry[1]
  },
  watch: {
    utility: function() {
      if(this.utility == 0) {
        this.utility = this.courseScore
      }
      this.courseScore = (this.utility + this.popularity + this.reasonability)/3
    },
    popularity: function() {
      if(this.popularity == 0) {
        this.popularity = this.courseScore
      }
      this.courseScore = (this.utility + this.popularity + this.reasonability)/3
    },
    reasonability: function() {
      if(this.reasonability == 0) {
        this.reasonability = this.courseScore
      }
      this.courseScore = (this.utility + this.popularity + this.reasonability)/3
    },
    interaction: function() {
      if(this.interaction == 0) {
        this.interaction = this.teacherScore
      }
      this.teacherScore = (this.interaction + this.discipline + this.affinity)/3
    },
    discipline: function() {
      if(this.discipline == 0) {
        this.discipline = this.teacherScore
      }
      this.teacherScore = (this.interaction + this.discipline + this.affinity)/3
    },
    affinity: function() {
      if(this.affinity == 0) {
        this.affinity = this.teacherScore
      }
      this.teacherScore = (this.interaction + this.discipline + this.affinity)/3
    },
    isShowList: function() {
      if(this.isShowList) {
        this.isHasCheck()
        this.intervalFun()
      }
    },
    time: function() {
      if(this.time == 0) {
        this.isShowCheck = false
      }else {
          if(this.time>0){
            this.isShowCheck = true
          }
      }
    }
  },
  mounted: function() {
    this.getList()
  },
  methods: {
    //倒计时
    countdown(time) {
      let self = this;
      let timer = setInterval(function() {
        time--;
        if(time>0) {
          let h = parseInt(time / (60 * 60))
          let m = parseInt((time % (60 * 60)) / 60)
          let s = parseInt((time % (60 * 60)) % 60)
          let format = '';
          format = (h >= 10 ? h : '0' + h) + ':' + (m >= 10 ? m : '0' + m) + ':' + (s >= 10 ? s : '0' + s);
          self.djs = format;
        }else {
          clearInterval(timer);
          self.djs = "00:00:00";
          self.isShowCheck = false;
        }
      },1000);
    },
    //轮询
    intervalFun() {
      let self = this
      self.interval = setInterval(() => {
        self.isHasCheck()
      }, 5000)
    },
    //点击展开
    showMore() {
      this.isShowMore = true
    },
    //点击收起
    closeMore() {
      this.isShowMore = false
    },
    //点击展开
    showMoreTwo() {
      this.isShowMoreTwo = true
    },
    //点击收起
    closeMoreTwo() {
      this.isShowMoreTwo = false
    },
    //查询列表
    getList() {
      this.$http.post(API_ROOT.college + '/merchantSchedule/queryTjkMerchantScheduleCourse', {'scheduleId': this.scheduleId}).then(response => {
        var result = response.data
        if(result.success) {
          //培训老师跳转至管理页面
          if(result.data.isTeacher == 'Yes') {
            window.location.href = '/tjkStudy/traincheck/list'
          }else {
            if(result.data.isLogin == 'No') {
              this.isShowLogin = true
              this.isShowList = false
            }else {
              this.description = result.data.description
              for(let i=0;i<result.data.courses.length;i++) {
                if(result.data.courses[i].isExpire == 'No') {
                  result.data.courses[i].isExpireFirst = 'Yes'
                  break
                }
              }
              this.list = result.data.courses
              if(result.data.templateId !='' && result.data.templateId != null && result.data.isSubmitQuestion == 'No') {
                this.isShowTemplate = true
                this.isShowList = false
                this.questionList = result.data.paramList
              }else {
                if(result.data.isRecruit == 'No') {
                  this.isShowRecruit = true
                  this.isShowList = false
                }else {
                  this.isShowList = true
                  this.isShowRecruit = false
                }
              } 
            }
          }
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //签到
    checkIn() {
      this.$http.post(API_ROOT.college + '/merchantSchedule/tjkSignCourse', {'courseId': this.checkCourseId}).then(response => {
        var result = response.data
        if(result.success) {
          this.isShowCheck = false
          this.isShowCheckSucc = true
          this.getList()
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //显示评价
    showPjia(courseId) {
      this.isShowList = false
      this.isShowPjia = true
      this.courseId = courseId
    },
    //返回签到
    gotoList() {
      this.isShowList = true
      this.isShowPjia = false
      this.isShowMore = true
      this.isShowMoreTwo = true
      this.courseScore = 0
      this.utility = 0
      this.popularity = 0
      this.reasonability = 0
      this.teacherScore = 0
      this.interaction = 0
      this.discipline = 0
      this.affinity = 0
      this.advice = ''
    },
    //提交评价
    submitPjia() {
      if(this.courseScore == 0 || this.teacherScore == 0) {
        this.$alert('请选择分数')
        return
      }
      let data = {
        'scheduleId': this.scheduleId,
        'courseId': this.courseId,
        'courseScore': parseFloat(this.courseScore).toFixed(2),
        'teacherScore': parseFloat(this.teacherScore).toFixed(2),
        'advice': this.advice,
        'courseEvaluateVO.utility': this.utility,
        'courseEvaluateVO.popularity': this.popularity,
        'courseEvaluateVO.reasonability': this.reasonability,
        'teacherEvaluateVO.interaction': this.interaction,
        'teacherEvaluateVO.discipline': this.discipline,
        'teacherEvaluateVO.affinity': this.affinity
      }
      this.$http.post(API_ROOT.college + '/merchantSchedule/tjkEvaluateCourse', data).then(response => {
        var result = response.data
        if(result.success) {
          this.isShowPjia = false
          this.isShowPjiaSucc = true
          this.courseScore = 0
          this.utility = 0
          this.popularity = 0
          this.reasonability = 0
          this.teacherScore = 0
          this.interaction = 0
          this.discipline = 0
          this.affinity = 0
          this.advice = ''
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //评价成功后返回
    closePjiaSucc() {
      this.isShowPjiaSucc = false
      this.isShowList = true
    },
    //登录
    login() {
      let self = this
      this.$refs.form.validate((valid) => {
        if(valid) {
          self.$http.post(API_ROOT.tjkuser + '/tjkLogin/login', self.form).then(response => {
            var result = response.data
            if(result.success) {
              window.location.reload()
            }else {
              self.$alert(result.msg)
            }
          }, response => {
            self.$alert('网络繁忙，请稍后重试！')
          })
        }else {
          return false;
        }
      });
    },
    //报名
    recruitFun() {
      this.$http.post(API_ROOT.college + '/merchantSchedule/createScheduleTjkRel', {'scheduleId': this.scheduleId}).then(response => {
        var result = response.data
        if(result.success) {
          this.isShowRecruit = false
          this.isShowList = true
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    },
    //提交问卷
    submitInfo() {
      var self = this,
          answerList = []
      this.wjform.answerList.forEach((v,i)=>{
        answerList.push({'paramId': i, 'value': v})
      })
      if(answerList.length < this.questionList.length) {
        this.$alert('你还有必填项未填')
        return false
      }
      for(let i=0;i<this.questionList.length;i++) {
        for(let j=0;j<answerList.length;j++) {
          if(this.questionList[i].paramId == answerList[j].paramId) {
            answerList[j].paramName = this.questionList[i].paramName
            answerList[j].paramType = this.questionList[i].paramType
            answerList[j].templateId = this.questionList[i].templateId
          }
        }
      }
      let data = {
        'scheduleId': this.scheduleId,
        'paramFullList': answerList
      }
      this.$http.post(API_ROOT.college + '/merchantSchedule/tjkSubmitDynamicTable', data).then(respones=> {
        var result = respones.data
        if(result.success) {
          this.$message({
            message: '提交成功',
            type: 'success',
            center: true,
            duration: 1000
          })
          window.location.reload()
        }else {
          this.$alert(result.msg)
        }
      },respones=> {
        this.$alert("网络繁忙，请稍后重试！")
      })
    },
    //查询是否有签到课程
    isHasCheck() {
      this.$http.post(API_ROOT.college + '/merchantSchedule/getSignExpireMinute', {'scheduleId': this.scheduleId}).then(response => {
        var result = response.data
        if(result.success) {
          this.time = result.data.seconds
          this.checkCourseId = result.data.courseId
          this.countdown(this.time)
        }else {
          this.$alert(result.msg)
        }
      }, response => {
        this.$alert('网络繁忙，请稍后重试！')
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// ./src/page/trainCheck/index.vue